/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlChatOpsUnsureVerdict = {
    Malicious: 'MALICIOUS',
    Suspicious: 'SUSPICIOUS',
    Benign: 'BENIGN'
} as const;
export type ControlChatOpsUnsureVerdict = typeof ControlChatOpsUnsureVerdict[keyof typeof ControlChatOpsUnsureVerdict];


export function ControlChatOpsUnsureVerdictFromJSON(json: any): ControlChatOpsUnsureVerdict {
    return ControlChatOpsUnsureVerdictFromJSONTyped(json, false);
}

export function ControlChatOpsUnsureVerdictFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlChatOpsUnsureVerdict {
    return json as ControlChatOpsUnsureVerdict;
}

export function ControlChatOpsUnsureVerdictToJSON(value?: ControlChatOpsUnsureVerdict | null): any {
    return value as any;
}

